import { useTranslation } from 'react-i18next';

import type { components } from 'wg-api-sdk';

import { Field, FieldLabel } from '@/components/shadcn/field';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/select';
import i18n, { AVAILABLE_LANGUAGES } from '@/lib/i18n/i18n';
import useUpdateUser from '@/mutations/useUpdateUser';

export default function LanguageSetting() {
  const { t } = useTranslation();

  const { mutateAsync: updateUser, isPending } = useUpdateUser();

  const handleChange = (code: (typeof AVAILABLE_LANGUAGES)[number]['code']) => {
    i18n.changeLanguage(code);

    const language = code
      .slice(0, 2)
      .toUpperCase() as components['schemas']['LANGUAGE_CODES'];

    updateUser({ language });
  };

  return (
    <Field>
      <FieldLabel>{t('SETTINGS_LANGUAGE_LABEL')}</FieldLabel>
      <Select
        value={i18n.language}
        onValueChange={handleChange}
        disabled={isPending}
      >
        <SelectTrigger className="w-full">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {AVAILABLE_LANGUAGES.map((lang) => (
            <SelectItem key={lang.code} value={lang.code}>
              {lang.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}
